var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSandClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.773,
    height: 44,
    viewBox: "0 0 24.773 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-173.044)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(173.044)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.045,4.994h1.772V3.258A3.258,3.258,0,0,0,194.559,0H176.3a3.258,3.258,0,0,0-3.258,3.258V4.993h1.772v5.364a8.9,8.9,0,0,0,1.106,4.3l3.49,6.337a2.014,2.014,0,0,1-.028,1.992l-3.341,5.69a8.906,8.906,0,0,0-1.227,4.512v5.819h-1.771v1.736A3.258,3.258,0,0,0,176.3,44h18.257a3.258,3.258,0,0,0,3.258-3.258V39.006h-1.772V33.187a8.906,8.906,0,0,0-1.227-4.512l-3.329-5.669a2.056,2.056,0,0,1-.029-2.034l3.478-6.315a8.9,8.9,0,0,0,1.106-4.3V4.994ZM193.22,9.908a7.834,7.834,0,0,1-.973,3.781l-3.666,6.656a3.4,3.4,0,0,0,.046,3.366l3.513,5.984a7.842,7.842,0,0,1,1.079,3.968v5.344h-1.976c-.9-1.245-3.155-2.133-5.813-2.133s-4.914.888-5.813,2.133h-1.977V33.663a7.842,7.842,0,0,1,1.079-3.968l3.514-5.984a3.4,3.4,0,0,0,.046-3.366l-3.666-6.656a7.835,7.835,0,0,1-.973-3.781V4.993h15.579V9.908Z",
    transform: "translate(-173.044)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.099 14.198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.4,255.561h-8.575l3.252,5.916a1.182,1.182,0,0,0,2.072,0Z",
    transform: "translate(-318.822 -255.561)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandClock);
export default __webpack_public_path__ + "static/media/sand-clock.0f56ab3a6dee042a8e4270ec0a4eb6e0.svg";
export { ForwardRef as ReactComponent };